import React from 'react'
import { TextField } from '@material-ui/core'
import { nameIsValid } from '../../../helpers/campaignForm.helpers'

type Props = {
  name: string
  setName: (name: string) => void
}

export const CampaignNameField = ({ name, setName }: Props) => (
  <div className="w-full grid grid-cols-1 sm:grid-cols-3 gap-4 py-4 items-start">
    <p className="text-sm font-semibold text-mm-neutral-1-700">Campaign Name</p>
    <TextField
      className="sm:col-span-2"
      id="campaignNameField"
      required
      autoFocus
      error={!nameIsValid(name)}
      // Only when it is actually wrong: the rule sat permanently in the error slot of a valid field.
      helperText={nameIsValid(name) ? undefined : 'Required, and under 256 characters'}
      label="Campaign Name"
      placeholder="Campaign Name"
      defaultValue={name}
      onChange={({ target }) => {
        setName(target.value)
      }}
    />
  </div>
)
